// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"start-speed-read_wrapper__2oE9l","text":"start-speed-read_text__2d2tB"};